import { AtivoMonitoramentoDetalhado } from './../ativo-monitoramento-detalhado.model copy';
import { SituacaoMonitoramento } from './../item-monitoramento.model';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ItemMonitoramentoDetalhado } from '../item-monitoramento-detalhado.model';

@Component({
  selector: 'app-ativo-visualizador',
  templateUrl: './ativo-visualizador.component.html',
  styleUrls: ['./ativo-visualizador.component.css'],
})
export class AtivoVisualizadorComponent implements OnChanges {
  @Input()
  public ativo: AtivoMonitoramentoDetalhado;
  public sucesso: boolean;

  public ngOnChanges(_: SimpleChanges) {
    if (this.ativo !== undefined) {
      this.sucesso = this.ativo.isSucesso();
    }
  }

  public getItemClasse(item: ItemMonitoramentoDetalhado): string {
    switch (item.situacao) {
      case SituacaoMonitoramento.SUCESSO:
        return 'label-success';
      case SituacaoMonitoramento.FALHA:
        return 'label-danger';
      case SituacaoMonitoramento.IGNORADO:
        return 'label-default label-ignorado';
    }
  }
}
